export const DEMO_SERVER = "filmatik-webviewer-demo.show.program-ace.net"
